import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "targeting-split-definition"
};
const _hoisted_2 = {
  class: "performance-targeting"
};
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", {
  class: "title"
}, "Performance Targeting", -1);
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", {
  class: "detail"
}, "Targeting that already converted at least once", -1);
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", {
  class: "empty"
}, null, -1);
const _hoisted_6 = {
  class: "definition-row"
};
const _hoisted_7 = {
  class: "detail"
};
const _hoisted_8 = {
  class: "split-name"
};
const _hoisted_9 = ["innerHTML"];
const _hoisted_10 = ["id", "innerHTML"];
const _hoisted_11 = ["innerHTML"];
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", {
  class: "flex-1 d-flex w-100"
}, "Spend", -1);
const _hoisted_13 = ["innerHTML"];
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", {
  class: "flex-1 d-flex w-100"
}, "Sales", -1);
const _hoisted_15 = ["innerHTML"];
const _hoisted_16 = ["innerHTML"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_flex_row = _resolveComponent("flex-row");
  const _component_dot_element = _resolveComponent("dot-element");
  const _component_flex_column = _resolveComponent("flex-column");
  const _component_dotted_value = _resolveComponent("dotted-value");
  const _component_wrap_with_info = _resolveComponent("wrap-with-info");
  const _component_filter_divider = _resolveComponent("filter-divider");
  const _component_view_export_dropdown = _resolveComponent("view-export-dropdown");
  const _component_wrap_with_popover = _resolveComponent("wrap-with-popover");
  const _component_coins_stacked_icon = _resolveComponent("coins-stacked-icon");
  const _component_app_switch = _resolveComponent("app-switch");
  const _component_percent_icon = _resolveComponent("percent-icon");
  const _component_AppIcon = _resolveComponent("AppIcon");
  const _component_hug_value = _resolveComponent("hug-value");
  const _component_date_value = _resolveComponent("date-value");
  const _component_number_value = _resolveComponent("number-value");
  const _component_bar_with_value = _resolveComponent("bar-with-value");
  const _component_percentage_value = _resolveComponent("percentage-value");
  const _component_overlap_bar_value = _resolveComponent("overlap-bar-value");
  const _component_variable_styled_bar = _resolveComponent("variable-styled-bar");
  const _component_layer_bars = _resolveComponent("layer-bars");
  const _component_bar_slot_with_value = _resolveComponent("bar-slot-with-value");
  const _component_currency_value = _resolveComponent("currency-value");
  const _component_composite_colorful_bar = _resolveComponent("composite-colorful-bar");
  const _component_boxed_value = _resolveComponent("boxed-value");
  const _component_dial_value = _resolveComponent("dial-value");
  const _component_slot_with_value = _resolveComponent("slot-with-value");
  const _component_b_table_lite = _resolveComponent("b-table-lite");
  const _component_compound_table = _resolveComponent("compound-table");
  const _component_wrap_table_with_show_more = _resolveComponent("wrap-table-with-show-more");
  return _openBlock(), _createBlock(_component_wrap_table_with_show_more, {
    modelValue: $options.period_pager,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $options.period_pager = $event),
    period: _ctx.period
  }, {
    default: _withCtx(() => [_createVNode(_component_compound_table, {
      class: "strategic-period-table",
      topBgColor: "#F8F9FF",
      topLeftGap: 20,
      fields: $options.fields,
      loading: $props.loading,
      errorOccurred: _ctx.periodTable.errorOccurred,
      onRetry: _cache[2] || (_cache[2] = $event => _ctx.$emit('refresh'))
    }, {
      header: _withCtx(() => [_createTextVNode(_toDisplayString($options.periodTitle), 1)]),
      "header-sub": _withCtx(() => [_createVNode(_component_wrap_with_info, {
        gap: 12,
        "popover-class": "targeting-definition",
        width: "auto"
      }, {
        body: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_flex_row, {
          align: "left",
          gap: 5
        }, {
          default: _withCtx(() => [_hoisted_3, _hoisted_4]),
          _: 1
        })]), _hoisted_5, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.TARGETING_TYPE_SPLIT, ({
          definition,
          dotColor
        }, index) => {
          return _openBlock(), _createElementBlock("div", {
            class: _normalizeClass(["definition", [`id-${index}`]]),
            key: index
          }, [_createElementVNode("div", _hoisted_6, [_createVNode(_component_dot_element, {
            color: dotColor,
            size: 12
          }, null, 8, ["color"]), _createVNode(_component_flex_column, {
            gap: 4,
            class: "definition-block"
          }, {
            default: _withCtx(() => [_createElementVNode("div", {
              class: "title",
              style: _normalizeStyle({
                ['--definition-title-color']: definition.titleColor
              })
            }, _toDisplayString(definition.title), 5), _createElementVNode("div", _hoisted_7, _toDisplayString(definition.detail), 1)]),
            _: 2
          }, 1024)])], 2);
        }), 128))])]),
        default: _withCtx(() => [_createVNode(_component_flex_row, {
          gap: 16
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.TARGETING_TYPE_SPLIT, ({
            name,
            dotColor
          }) => {
            return _openBlock(), _createBlock(_component_dotted_value, {
              gap: 8,
              value: name,
              color: dotColor,
              size: 12,
              styles: {
                padding: 0
              }
            }, {
              default: _withCtx(() => [_createElementVNode("span", _hoisted_8, _toDisplayString(name), 1)]),
              _: 2
            }, 1032, ["value", "color"]);
          }), 256))]),
          _: 1
        })]),
        _: 1
      })]),
      "group-by-title": _withCtx(() => [_createVNode(_component_filter_divider, {
        height: 20
      })]),
      actions: _withCtx(() => [_createVNode(_component_view_export_dropdown, {
        onCsvDownload: $options.downloadStrategicPeriodCSV,
        onGoogleSheetDownload: $options.downloadStrategicGoogleSheet,
        onCsvCopy: $options.copyStrategicPeriodCSV
      }, null, 8, ["onCsvDownload", "onGoogleSheetDownload", "onCsvCopy"])]),
      table: _withCtx(() => [_createVNode(_component_b_table_lite, {
        class: _normalizeClass(['lite-table', 'lite-table-hoverable', 'strategic-performance-table']),
        fields: $options.fields,
        bordered: "",
        responsive: "",
        fixed: "",
        items: $options.items,
        "sticky-header": "",
        tbodyTrClass: item => _ctx.handleRowClass(item, $options.items),
        onRowClicked: _cache[1] || (_cache[1] = item => _ctx.handleRowClicked(item, $options.handleDateReset, $options.handleDateClick, 'period_agg'))
      }, {
        "head()": _withCtx(col => [_createVNode(_component_flex_row, {
          styles: {
            justifyContent: col.field.justify,
            ...col.field?.thStyle
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_wrap_with_popover, {
            target: `strategic-period-table-${col?.label}`,
            style: {
              width: '100%'
            }
          }, {
            title: _withCtx(() => [_createElementVNode("div", {
              innerHTML: $options.getDescriptionBasedOnKpiKey(col?.column).title
            }, null, 8, _hoisted_9)]),
            content: _withCtx(() => [_createTextVNode(_toDisplayString($options.getDescriptionBasedOnKpiKey(col?.column).detail), 1)]),
            default: _withCtx(() => [_createElementVNode("div", {
              id: `strategic-period-table-${col?.label}`,
              innerHTML: col?.column === 'period_agg' ? $options.getPeriodColumnTitle : col?.label,
              class: "title"
            }, null, 8, _hoisted_10)]),
            _: 2
          }, 1032, ["target"])]),
          _: 2
        }, 1032, ["styles"])]),
        "head(big_spend)": _withCtx(col => [_createVNode(_component_flex_row, {
          styles: {
            justifyContent: 'space-between',
            ...col.field?.thStyle,
            ['--app-switch-simple-bg']: 'var(--market-500)',
            ['--app-switch-off-bg']: 'var(--market-500)'
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_wrap_with_popover, {
            target: `strategic-period-table-spend`,
            style: {
              width: 'fit-content'
            }
          }, {
            title: _withCtx(() => [_createElementVNode("div", {
              innerHTML: $options.getDescriptionBasedOnKpiKey('spend').title
            }, null, 8, _hoisted_11)]),
            content: _withCtx(() => [_createTextVNode(_toDisplayString($options.getDescriptionBasedOnKpiKey("spend").detail), 1)]),
            default: _withCtx(() => [_createVNode(_component_flex_row, {
              gap: 4,
              id: "strategic-period-table-spend",
              class: _normalizeClass(['split-type', {
                inactive: $data.spendSales === true
              }])
            }, {
              default: _withCtx(() => [_createVNode(_component_coins_stacked_icon, {
                width: "20",
                height: "20"
              }), _hoisted_12]),
              _: 1
            }, 8, ["class"])]),
            _: 1
          }), _createVNode(_component_app_switch, {
            modelValue: $data.spendSales,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.spendSales = $event),
            simple: "",
            onChange: $options.switchSpendSales
          }, null, 8, ["modelValue", "onChange"]), _createVNode(_component_wrap_with_popover, {
            target: `strategic-period-table-sales`,
            style: {
              width: 'fit-content'
            }
          }, {
            title: _withCtx(() => [_createElementVNode("div", {
              innerHTML: $options.getDescriptionBasedOnKpiKey('sponsored_sales').title
            }, null, 8, _hoisted_13)]),
            content: _withCtx(() => [_createTextVNode(_toDisplayString($options.getDescriptionBasedOnKpiKey("sponsored_sales").detail), 1)]),
            default: _withCtx(() => [_createVNode(_component_flex_row, {
              gap: 4,
              id: "strategic-period-table-sales",
              class: _normalizeClass(['split-type', {
                inactive: $data.spendSales === false
              }])
            }, {
              default: _withCtx(() => [_createVNode(_component_percent_icon, {
                width: "20",
                height: "20"
              }), _hoisted_14]),
              _: 1
            }, 8, ["class"])]),
            _: 1
          })]),
          _: 2
        }, 1032, ["styles"])]),
        "head(targeting_type_ROAS)": _withCtx(col => [_createVNode(_component_flex_row, {
          styles: {
            justifyContent: col.field.justify,
            ...col.field?.thStyle
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_wrap_with_popover, {
            target: `strategic-period-table-targeting_type_ROAS`,
            style: {
              width: '100%'
            }
          }, {
            title: _withCtx(() => [_createElementVNode("div", {
              innerHTML: $options.getDescriptionBasedOnKpiKey('ROAS').title
            }, null, 8, _hoisted_15)]),
            content: _withCtx(() => [_createTextVNode(_toDisplayString($options.getDescriptionBasedOnKpiKey("ROAS").detail), 1)]),
            default: _withCtx(() => [_createElementVNode("div", {
              id: "strategic-period-table-targeting_type_ROAS",
              innerHTML: col?.label
            }, null, 8, _hoisted_16)]),
            _: 2
          }, 1024)]),
          _: 2
        }, 1032, ["styles"])]),
        "cell(selector)": _withCtx(row => [_createVNode(_component_hug_value, {
          loading: $props.loading
        }, {
          default: _withCtx(() => [_createVNode(_component_AppIcon, {
            icon: `zoom-${row.item.selected ? 'out' : 'in'}`,
            color: row.item.selected ? null : '#ADADAD',
            size: 16
          }, null, 8, ["icon", "color"])]),
          _: 2
        }, 1032, ["loading"])]),
        "cell(period_agg)": _withCtx(row => [_createVNode(_component_date_value, {
          value: row.item?.period_agg,
          format: $options.getDateValueFormat,
          styles: {
            justifyContent: 'flex-start',
            ..._ctx.activateDateValueStyles(row)
          },
          loading: $props.loading
        }, null, 8, ["value", "format", "styles", "loading"])]),
        "cell(sponsored_asin)": _withCtx(row => [_createVNode(_component_bar_with_value, {
          value: row.item?.sponsored_asin,
          color: "#4C8EFF",
          min: $options.minMax?.sponsored_asin?.min,
          max: $options.minMax?.sponsored_asin?.max,
          loading: $props.loading
        }, {
          default: _withCtx(() => [_createVNode(_component_number_value, {
            value: row.item?.sponsored_asin,
            charCount: $options.maxCharCount.number?.sponsored_asin,
            style: {
              padding: 0
            }
          }, null, 8, ["value", "charCount"])]),
          _: 2
        }, 1032, ["value", "min", "max", "loading"])]),
        "cell(cannibalization_pc)": _withCtx(row => [_createVNode(_component_hug_value, {
          loading: $props.loading
        }, {
          default: _withCtx(() => [_createVNode(_component_percentage_value, {
            value: row.item?.cannibalization_pc
          }, null, 8, ["value"])]),
          _: 2
        }, 1032, ["loading"])]),
        "cell(TACOS)": _withCtx(row => [_createVNode(_component_overlap_bar_value, {
          value: row.item?.TACOS,
          background: "#EBD4F7",
          borderColor: "#CD93EB",
          min: $options.minMax?.TACOS?.min,
          max: $options.minMax?.TACOS?.max,
          loading: $props.loading
        }, {
          default: _withCtx(() => [_createVNode(_component_percentage_value, {
            value: row.item?.TACOS
          }, null, 8, ["value"])]),
          _: 2
        }, 1032, ["value", "min", "max", "loading"])]),
        "cell(percent_time_in_budget)": _withCtx(row => [_createVNode(_component_bar_slot_with_value, {
          loading: $props.loading,
          value: row.item?.percent_time_in_budget,
          reverse: ""
        }, {
          bar: _withCtx(() => [_createVNode(_component_layer_bars, null, {
            default: _withCtx(() => [_createVNode(_component_variable_styled_bar, {
              value: $options.minMax?.percent_time_in_budget?.max,
              max: $options.minMax?.percent_time_in_budget?.max,
              min: $options.minMax?.percent_time_in_budget?.min,
              color: "#E8EBF3",
              height: "6"
            }, null, 8, ["value", "max", "min"]), _createVNode(_component_variable_styled_bar, {
              value: row.item?.percent_time_in_budget,
              max: $options.minMax?.percent_time_in_budget?.max,
              min: $options.minMax?.percent_time_in_budget?.min,
              color: "#5F799B",
              height: "6"
            }, null, 8, ["value", "max", "min"])]),
            _: 2
          }, 1024)]),
          default: _withCtx(() => [_createVNode(_component_percentage_value, {
            value: row.item?.percent_time_in_budget,
            charCount: $options.maxCharCount.percentage?.percent_time_in_budget
          }, null, 8, ["value", "charCount"])]),
          _: 2
        }, 1032, ["loading", "value"])]),
        "cell(share_sponsored_sales)": _withCtx(row => [_createVNode(_component_bar_with_value, {
          value: row.item?.share_sponsored_sales,
          min: $options.minMax?.share_sponsored_sales?.min,
          color: "#5A52AE",
          max: $options.minMax?.share_sponsored_sales?.max,
          loading: $props.loading
        }, {
          default: _withCtx(() => [_createVNode(_component_percentage_value, {
            value: row.item?.share_sponsored_sales,
            charCount: $options.maxCharCount.percentage?.share_sponsored_sales
          }, null, 8, ["value", "charCount"])]),
          _: 2
        }, 1032, ["value", "min", "max", "loading"])]),
        "cell(big_spend)": _withCtx(row => [_createVNode(_component_bar_slot_with_value, {
          loading: $props.loading,
          onMouseenter: $event => $options.handleShowComposites(row.index),
          onMouseleave: $event => $options.handleHideComposites(row.index)
        }, {
          bar: _withCtx(() => [_createVNode(_component_composite_colorful_bar, {
            ref: `spendComposite_${row.index}`,
            barValues: $options.spendSalesValues(row),
            values: {
              SPEND: [$options.findTargetingTypePercentage($data.TARGETING_TYPE_TYPES.COMPETITORS_PRODUCT, row.item?.targeting_type_spend, row.item?.big_spend), $options.findTargetingTypePercentage($data.TARGETING_TYPE_TYPES.NON_BRANDED_KWS, row.item?.targeting_type_spend, row.item?.big_spend), $options.findTargetingTypePercentage($data.TARGETING_TYPE_TYPES.BRANDED, row.item?.targeting_type_spend, row.item?.big_spend), $options.findTargetingTypePercentage($data.TARGETING_TYPE_TYPES.DISCOVERY, row.item?.targeting_type_spend, row.item?.big_spend)],
              SPONSORED_SALES: [$options.findTargetingTypePercentage($data.TARGETING_TYPE_TYPES.COMPETITORS_PRODUCT, row.item?.targeting_type_sponsored_sales, row.item?.big_sponsored_sales), $options.findTargetingTypePercentage($data.TARGETING_TYPE_TYPES.NON_BRANDED_KWS, row.item?.targeting_type_sponsored_sales, row.item?.big_sponsored_sales), $options.findTargetingTypePercentage($data.TARGETING_TYPE_TYPES.BRANDED, row.item?.targeting_type_sponsored_sales, row.item?.big_sponsored_sales), $options.findTargetingTypePercentage($data.TARGETING_TYPE_TYPES.DISCOVERY, row.item?.targeting_type_sponsored_sales, row.item?.big_sponsored_sales)]
            },
            currencies: {
              SPEND: [$options.findTargetingTypeValue($data.TARGETING_TYPE_TYPES.COMPETITORS_PRODUCT, row.item?.targeting_type_spend), $options.findTargetingTypeValue($data.TARGETING_TYPE_TYPES.NON_BRANDED_KWS, row.item?.targeting_type_spend), $options.findTargetingTypeValue($data.TARGETING_TYPE_TYPES.BRANDED, row.item?.targeting_type_spend), $options.findTargetingTypeValue($data.TARGETING_TYPE_TYPES.DISCOVERY, row.item?.targeting_type_spend)],
              SPONSORED_SALES: [$options.findTargetingTypeValue($data.TARGETING_TYPE_TYPES.COMPETITORS_PRODUCT, row.item?.targeting_type_sponsored_sales), $options.findTargetingTypeValue($data.TARGETING_TYPE_TYPES.NON_BRANDED_KWS, row.item?.targeting_type_sponsored_sales), $options.findTargetingTypeValue($data.TARGETING_TYPE_TYPES.BRANDED, row.item?.targeting_type_sponsored_sales), $options.findTargetingTypeValue($data.TARGETING_TYPE_TYPES.DISCOVERY, row.item?.targeting_type_sponsored_sales)]
            },
            min: 0,
            max: row.item?.[$data.spendSales ? 'sponsored_sales' : 'spend'],
            colors: [$data.COLORS.COMPETITORS_PURPLE, $data.COLORS.NON_BRANDED_BLUE, $data.COLORS.BRANDED_PINK, $data.COLORS.DISCOVERY_GREY],
            types: $data.TARGETING_TYPE_SPLIT,
            activeType: $data.spendSales ? 'SPONSORED_SALES' : 'SPEND'
          }, {
            date: _withCtx(() => [_createVNode(_component_date_value, {
              value: row.item?.period_agg,
              format: $options.getDateValueFormat,
              align: "left",
              loading: $props.loading,
              styles: {
                width: '100%'
              }
            }, null, 8, ["value", "format", "loading"])]),
            "spend-total": _withCtx(() => [_createVNode(_component_currency_value, {
              value: row.item?.big_spend,
              limit: 1_000,
              precision: 2,
              "zero-initials": ""
            }, null, 8, ["value"])]),
            "sponsored-total": _withCtx(() => [_createVNode(_component_currency_value, {
              value: row.item?.big_sponsored_sales,
              limit: 1_000,
              precision: 2,
              "zero-initials": ""
            }, null, 8, ["value"])]),
            _: 2
          }, 1032, ["barValues", "values", "currencies", "max", "colors", "types", "activeType"])]),
          default: _withCtx(() => [_createVNode(_component_currency_value, {
            value: row.item?.[$data.spendSales ? 'sponsored_sales' : 'spend'],
            charCount: $options.maxCharCount?.currency?.[[$data.spendSales ? 'sponsored_sales' : 'spend']]
          }, null, 8, ["value", "charCount"])]),
          _: 2
        }, 1032, ["loading", "onMouseenter", "onMouseleave"])]),
        "cell(targeting_type_ROAS)": _withCtx(row => [_createVNode(_component_flex_row, null, {
          default: _withCtx(() => [_createVNode(_component_boxed_value, {
            value: row.item?.targeting_type_ROAS?.[0]?.targeting_type_ROAS,
            bgColor: $options.getTargetingTypeSplitDecileColor(row, 'targeting_type_ROAS', $data.TARGETING_TYPE_TYPES.COMPETITORS_PRODUCT),
            loading: $props.loading,
            align: "center"
          }, {
            default: _withCtx(() => [_createVNode(_component_number_value, {
              tight: "",
              value: $options.findTargetingTypeValue($data.TARGETING_TYPE_TYPES.COMPETITORS_PRODUCT, row.item?.targeting_type_ROAS),
              precision: 1,
              color: $data.COLORS.PURPLE700
            }, null, 8, ["value", "color"])]),
            _: 2
          }, 1032, ["value", "bgColor", "loading"]), _createVNode(_component_boxed_value, {
            value: $options.findTargetingTypeValue($data.TARGETING_TYPE_TYPES.NON_BRANDED_KWS, row.item?.targeting_type_ROAS),
            bgColor: $options.getTargetingTypeSplitDecileColor(row, 'targeting_type_ROAS', $data.TARGETING_TYPE_TYPES.NON_BRANDED_KWS),
            loading: $props.loading,
            align: "center"
          }, {
            default: _withCtx(() => [_createVNode(_component_number_value, {
              tight: "",
              value: $options.findTargetingTypeValue($data.TARGETING_TYPE_TYPES.NON_BRANDED_KWS, row.item?.targeting_type_ROAS),
              precision: 1,
              color: $data.COLORS.BLUE800
            }, null, 8, ["value", "color"])]),
            _: 2
          }, 1032, ["value", "bgColor", "loading"]), _createVNode(_component_boxed_value, {
            value: $options.findTargetingTypeValue($data.TARGETING_TYPE_TYPES.BRANDED, row.item?.targeting_type_ROAS),
            bgColor: $options.getTargetingTypeSplitDecileColor(row, 'targeting_type_ROAS', $data.TARGETING_TYPE_TYPES.BRANDED),
            loading: $props.loading,
            align: "center"
          }, {
            default: _withCtx(() => [_createVNode(_component_number_value, {
              tight: "",
              value: $options.findTargetingTypeValue($data.TARGETING_TYPE_TYPES.BRANDED, row.item?.targeting_type_ROAS),
              precision: 1,
              color: $data.COLORS.PINK700
            }, null, 8, ["value", "color"])]),
            _: 2
          }, 1032, ["value", "bgColor", "loading"]), _createVNode(_component_boxed_value, {
            value: $options.findTargetingTypeValue($data.TARGETING_TYPE_TYPES.DISCOVERY, row.item?.targeting_type_ROAS),
            bgColor: $options.getTargetingTypeSplitDecileColor(row, 'targeting_type_ROAS', $data.TARGETING_TYPE_TYPES.DISCOVERY),
            loading: $props.loading,
            align: "center"
          }, {
            default: _withCtx(() => [_createVNode(_component_number_value, {
              tight: "",
              value: $options.findTargetingTypeValue($data.TARGETING_TYPE_TYPES.DISCOVERY, row.item?.targeting_type_ROAS),
              precision: 1,
              color: $data.COLORS.GREY700
            }, null, 8, ["value", "color"])]),
            _: 2
          }, 1032, ["value", "bgColor", "loading"])]),
          _: 2
        }, 1024)]),
        "cell(targeting_type_CPC)": _withCtx(row => [_createVNode(_component_flex_row, null, {
          default: _withCtx(() => [_createVNode(_component_boxed_value, {
            value: row.item?.targeting_type_CPC?.[0]?.targeting_type_CPC,
            bgColor: $options.getTargetingTypeSplitDecileColor(row, 'targeting_type_CPC', $data.TARGETING_TYPE_TYPES.COMPETITORS_PRODUCT),
            loading: $props.loading,
            align: "center"
          }, {
            default: _withCtx(() => [_createVNode(_component_currency_value, {
              value: $options.findTargetingTypeValue($data.TARGETING_TYPE_TYPES.COMPETITORS_PRODUCT, row.item?.targeting_type_CPC),
              precision: 2,
              color: $data.COLORS.PURPLE700
            }, null, 8, ["value", "color"])]),
            _: 2
          }, 1032, ["value", "bgColor", "loading"]), _createVNode(_component_boxed_value, {
            value: $options.findTargetingTypeValue($data.TARGETING_TYPE_TYPES.NON_BRANDED_KWS, row.item?.targeting_type_CPC),
            bgColor: $options.getTargetingTypeSplitDecileColor(row, 'targeting_type_CPC', $data.TARGETING_TYPE_TYPES.NON_BRANDED_KWS),
            loading: $props.loading,
            align: "center"
          }, {
            default: _withCtx(() => [_createVNode(_component_currency_value, {
              value: $options.findTargetingTypeValue($data.TARGETING_TYPE_TYPES.NON_BRANDED_KWS, row.item?.targeting_type_CPC),
              precision: 2,
              color: $data.COLORS.BLUE800
            }, null, 8, ["value", "color"])]),
            _: 2
          }, 1032, ["value", "bgColor", "loading"]), _createVNode(_component_boxed_value, {
            value: $options.findTargetingTypeValue($data.TARGETING_TYPE_TYPES.BRANDED, row.item?.targeting_type_CPC),
            bgColor: $options.getTargetingTypeSplitDecileColor(row, 'targeting_type_CPC', $data.TARGETING_TYPE_TYPES.BRANDED),
            loading: $props.loading,
            align: "center"
          }, {
            default: _withCtx(() => [_createVNode(_component_currency_value, {
              value: $options.findTargetingTypeValue($data.TARGETING_TYPE_TYPES.BRANDED, row.item?.targeting_type_CPC),
              precision: 2,
              color: $data.COLORS.PINK700
            }, null, 8, ["value", "color"])]),
            _: 2
          }, 1032, ["value", "bgColor", "loading"]), _createVNode(_component_boxed_value, {
            value: $options.findTargetingTypeValue($data.TARGETING_TYPE_TYPES.DISCOVERY, row.item?.targeting_type_CPC),
            bgColor: $options.getTargetingTypeSplitDecileColor(row, 'targeting_type_CPC', $data.TARGETING_TYPE_TYPES.DISCOVERY),
            loading: $props.loading,
            align: "center"
          }, {
            default: _withCtx(() => [_createVNode(_component_currency_value, {
              value: $options.findTargetingTypeValue($data.TARGETING_TYPE_TYPES.DISCOVERY, row.item?.targeting_type_CPC),
              precision: 2,
              color: $data.COLORS.GREY700
            }, null, 8, ["value", "color"])]),
            _: 2
          }, 1032, ["value", "bgColor", "loading"])]),
          _: 2
        }, 1024)]),
        "cell(total_ROAS)": _withCtx(row => [_createVNode(_component_overlap_bar_value, {
          value: row.item?.total_ROAS,
          background: "#E6E9FE",
          borderColor: "#D8DCFD",
          min: $options.minMax?.total_ROAS?.min,
          max: $options.minMax?.total_ROAS?.max,
          loading: $props.loading,
          align: "left"
        }, {
          default: _withCtx(() => [_createVNode(_component_number_value, {
            styles: {
              padding: 0
            },
            value: row.item?.total_ROAS,
            precision: 1
          }, null, 8, ["value"])]),
          _: 2
        }, 1032, ["value", "min", "max", "loading"])]),
        "cell(share_of_voice)": _withCtx(row => [_createVNode(_component_slot_with_value, {
          gap: 8,
          value: row.item?.share_of_voice
        }, {
          value: _withCtx(() => [_createVNode(_component_percentage_value, {
            value: row.item?.share_of_voice,
            color: "#DB2473"
          }, null, 8, ["value"])]),
          indicator: _withCtx(() => [_createVNode(_component_dial_value, {
            value: row.item?.share_of_voice ?? 0
          }, null, 8, ["value"])]),
          _: 2
        }, 1032, ["value"])]),
        _: 1
      }, 8, ["fields", "items", "tbodyTrClass"])]),
      _: 1
    }, 8, ["fields", "loading", "errorOccurred"])]),
    _: 1
  }, 8, ["modelValue", "period"]);
}